// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__MdXnf","savePackageButton":"ClientWallet_savePackageButton__38OiA"};